import styled from "styled-components";

export const SettingContainer = styled.div`
  position: relative;
`;